import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import { hasDashboardPageAccess } from 'src/utils/dashboardAccess';

export default function DashboardBreadcrumbLink({ sx }) {
  if (!hasDashboardPageAccess()) {
    return null;
  }

  return (
    <Link underline="hover" color="inherit" href="/" sx={sx}>
      Dashboard
    </Link>
  );
}

DashboardBreadcrumbLink.propTypes = {
  sx: PropTypes.object,
};
